import { makeStyles } from '@material-ui/core/styles';

export const useStyles = lightButton =>
  makeStyles(theme => ({
    button: {
      fontWeight: 400,
      fontSize: theme.fonts.sizes.font12PX,
      backgroundColor: lightButton
        ? theme.colors.light.freshPowder
        : theme.colors.light.snow,
      border: `2px solid ${
        lightButton ? theme.colors.light.freshPowder : theme.colors.light.snow
      }`,
      boxShadow: '0px 8px 12px rgba(136, 141, 168, 0.14)',

      '&:hover': {
        backgroundColor: theme.colors.light.freshPowder,
      },
    },
    leftButton: {
      marginRight: 8,
    },
    selectedButton: {
      borderColor: theme.colors.orange.orange,
      backgroundColor: theme.colors.light.freshPowder,
    },
  }));
